<template>
    <information-popup modal-id="inscriptionGuidelinesPopup" v-bind:info="info">
        <template slot="header">Inscription Guidelines</template>
        <slot>
            <div class="modal-body">
                <p>
				<span class="bld">12" x 12" PAVER</span>: 20 characters allowed per line. Characters include all letters, numbers, punctuation marks, and blank spaces found on a standard English keyboard. Inscriptions will be automatically centered and engraved in uppercase letters. Inscriptions that contain websites, phone numbers, twitter handles, and/or manifestos are not permitted. Discriminatory, political, offensive or inappropriate messages as determined by California State University, Fullerton will be declined.
				</p><p>
				<span class="bld">TREE PLAQUE</span>: 25 characters allowed per line. Characters include all letters, numbers, punctuation marks, and blank spaces found on a standard English keyboard. Inscriptions will be automatically centered and engraved in uppercase letters. Inscriptions that contain websites, phone numbers, twitter handles, and/or manifestos are not permitted. Discriminatory, political, offensive or inappropriate messages as determined by California State University, Fullerton will be declined.
				</p><p>
				<span class="bld">STUDY NOOK PLAQUE</span>: 28 characters allowed per line. Characters include all letters, numbers, punctuation marks, and blank spaces found on a standard English keyboard. Inscriptions will be automatically centered and engraved in uppercase letters. Inscriptions that contain websites, phone numbers, twitter handles, and/or manifestos are not permitted. Discriminatory, political, offensive or inappropriate messages as determined by California State University, Fullerton will be declined.
				</p>
            </div>
        </slot>
    </information-popup>
</template>

<script type="text/jsx">
    import InformationPopup from '@/components/popup/information-popup.vue';
    export default {
        name: 'inscription-guidelines',
        props: {
            info: {
                type: Object, // can be modified by child component
                required: false,
                default: function () {
                    return {
                        max_chars: 16 // minimal known value as default
                    };
                }
            }
        },
        components: {
            'information-popup': InformationPopup
        }
    }
</script>

<style>
.bld{
font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// InscriptionGuidelines.vue?49b0fa9a